export const dyanamicIpData = ({ ip, index }) => {
  return {
    fromIp: {
      key: `From_IP - ${index}`,
      title: "From IP",
      id: `from_ip - ${index}`,
      name: "from_ip",
      type: "text",
      // placeholder: "From IP",
      // onChange={handleChnage}
      value: ip?.from_ip,
      isEditUser: true,
    },
    toIp: {
      key: `To_IP - ${index}`,
      title: "To IP",
      id: `to_ip - ${index}`,
      name: "to_ip",
      type: "text",
      // placeholder: "To IP",
      // onChange={handleChnage},
      value: ip?.to_ip,
      isEditUser: true,
    },
  };
};
